<script lang="ts">
    import {aboutYouAndYourCarForm} from "./aboutYouForm";
    import Input from "./Input.svelte";
    import {aboutYouDetails, totalPriceToTwoDecimalPlaces} from "./stores";
    import {push} from 'svelte-spa-router'
    import CouponCodeEntry from "./CouponCodeEntry.svelte";
    import {
        checkCouponCode,
        couponErrorMessage,
        enteredCouponCode,
        enteredEmail,
        isCheckingCoupon
    } from "./state/appState";
    import type {IdAndLabel} from "@docsndata/lang-util";
    import {idAndLabel, strings} from "@docsndata/lang-util";

    const {
        form,
        errors,
        state,
        handleChange,
        handleSubmit
    } = aboutYouAndYourCarForm($aboutYouDetails, values => {
        $aboutYouDetails = values
        if (whereDidYouHearOption) {
            $aboutYouDetails.howDidYouHearAboutUs = whereDidYouHearOption.label
        }
        push("/pay")
    })

    const inputGroupDivClass = ""

    function initFocus(_el: any) {
        window.scrollTo(0, 0)
    }

    async function handleEmailChange(event: Event) {
        await handleChange(event)
        if (event.type === "change") {
            const errorLength = $state.errors.email.trim().length
            const emailLength = $state.form.email.trim().length
            if (errorLength === 0 && emailLength > 0) {
                $enteredEmail = $state.form.email
                await checkCouponCode($enteredCouponCode, $enteredEmail)
            }
        }
    }

    let whereDidYouHearOption: IdAndLabel | null = null

    function whereDidYouHearFromUsClicked(event: Event) {
        const target = event.target as HTMLInputElement
        whereDidYouHearOption = whereDidYouHearOptions.find(o => o.id === target.id)
    }

    const whereDidYouHearOptions = ["Referral", "Google", "Bark", "Instagram", "Facebook", "Leaflet", "Sylvester", "Nate", "Marlene", "Saw one of our vans", "Returning customer"].map(s => idAndLabel(strings.camelize(s), s))
</script>

<div class="text-center my-2">Total = £ {$totalPriceToTwoDecimalPlaces}</div>
<h4 class="text-center" use:initFocus>About you</h4>

<form on:submit={handleSubmit}>
    <div class={inputGroupDivClass}>
        <Input {form} name="firstName" label="First name" {handleChange} {errors}/>
    </div>
    <div class={inputGroupDivClass}>
        <Input {form} name="lastName" label="Last name" {handleChange} {errors}/>
    </div>
    <div class={inputGroupDivClass}>
        <Input {form} name="phone" label="Phone" {handleChange} {errors}/>
    </div>
    <div class={inputGroupDivClass}>
        <Input {form} name="email" label="Email" type="email" handleChange={handleEmailChange} {errors}/>
    </div>
    <div class={inputGroupDivClass}>
        <Input {form} name="firstLineOfAddress" label="What is the first line of your address" {handleChange} {errors}/>
    </div>
    <div class={inputGroupDivClass}>
        <Input {form} name="postcode" label="What is your postcode" {handleChange} {errors}/>
    </div>

    <h4 class="text-center">About your car</h4>

    <div class={inputGroupDivClass}>
        <Input {form} name="makeOfCar" label="What is the make of your car" {handleChange} {errors}/>
    </div>
    <div class={inputGroupDivClass}>
        <Input {form} name="modelOfCar" label="What is the model of your car" {handleChange} {errors}/>
    </div>
    <div class={inputGroupDivClass}>
        <Input {form} name="yearAndColourOfCar" label="What is the year and colour of your car" {handleChange}
               {errors}/>
    </div>
    <div class={inputGroupDivClass}>
        <Input {form} name="notes" type="textarea"
               label="Notes. Have a second car? Please state the make, registration and service required. Any specific request? Such as pet hair removal, stain & scratch removal - Just let us know !"
               {handleChange} {errors}/>
    </div>

    <p class="form-label">Where did you hear about us?</p>
    {#each whereDidYouHearOptions as option}
        <div class="form-check">
            <input class="form-check-input" type="radio" name="whereDidYouHearOfUs" id={option.id}
                   on:click={whereDidYouHearFromUsClicked}>
            <label class="form-check-label" for={option.id}>
                {option.label}
            </label>
        </div>
    {/each}

    <div class="mt-3 mb-3">
        <CouponCodeEntry/>
    </div>

    <button type="submit" class="btn btn-success pay-now-button px-5 py-2"
            disabled={$isCheckingCoupon || $couponErrorMessage !== null}>Pay Now
    </button>
</form>

